












import Chart from './Chart';
import 'echarts/lib/chart/pie';
import { SeriesItemProp } from './Visualization';

export default {
  name: 'PieChart',
  components: {
    Chart,
  },
  props: {
    series: {
      type: Array as SeriesItemProp[],
      default: [],
    },
  },
  computed: {
    options() {
      const { series } = this;

      const data = series.map(item => ({
        value: item.value,
        name: item.label,
        labelId: item.labelId,
        itemStyle: {
          color: item.color,
        },
      }));

      return {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            data,
          },
        ],
      };
    },
  },
};
